"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
/**
 * Class represents workflow's state
 */
var StateDto = /** @class */ (function () {
    function StateDto(id, name, description, processId, isFinal) {
        this._id = id;
        this._name = name;
        this._description = description || new Map();
        this._processId = processId;
        this._isFinal = isFinal;
    }
    /**
     * Get state id
     */
    StateDto.prototype.getId = function () {
        return this._id;
    };
    /**
     * Get state name
     */
    StateDto.prototype.getName = function () {
        return new idm_crosscutting_concepts_frontend_1.MultilingualString(this._name);
    };
    /**
     * Get state description
     */
    StateDto.prototype.getDescription = function () {
        return new idm_crosscutting_concepts_frontend_1.MultilingualString(this._description);
    };
    /**
     * Get state's name as map
     * @returns {Map<number, string>}
     */
    StateDto.prototype.getNameMap = function () {
        return this._name;
    };
    /**
     * Get state's description as map
     * @returns {Map<number, string>}
     */
    StateDto.prototype.getDescriptionMap = function () {
        return this._description;
    };
    /**
     * Get state's process id
     */
    StateDto.prototype.getProcessId = function () {
        return this._processId;
    };
    /**
     * Get state's is final
     */
    StateDto.prototype.getIsFinal = function () {
        return this._isFinal;
    };
    StateDto.prototype.toJsonObject = function () {
        var nameObject = {};
        var descriptionObject = {};
        this._name.forEach(function (value, key) {
            nameObject[key] = value;
        });
        this._description.forEach(function (value, key) {
            descriptionObject[key] = value;
        });
        return {
            id: this._id,
            name: nameObject,
            description: descriptionObject,
            processId: this._processId,
            isFinal: this._isFinal
        };
    };
    StateDto.prototype.toJson = function () {
        return JSON.stringify(this.toJsonObject());
    };
    return StateDto;
}());
exports.StateDto = StateDto;
//# sourceMappingURL=state.dto.js.map